<template>
  <div class="" style="display: contents;">
    <button type="button" class="btn scanner fixed" @click="scanqr()"><i class="fas fa-qrcode fa-2x"></i></button>
  </div>
</template>

<script>
// var host = process.env.VUE_APP_API
export default {
  name: 'Scanbutton',
  props: {
    result: String
  },
  data () {
    return {
      // jwt: localStorage.getItem('jwt')
    }
  },
  methods: {
    scanqr () {
      window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({ 'command': 'scanqr', 'data': {}}))
    }
  },
  computed: {
    // result () {
    //   return this.$route.params.result
    // }
  },
  created () {
    // this.getOmbrello()
    // console.log(this.jwt)
    // if (this.jwt) {
    //   console.log('ok')
    //   // this.$router.replace('Login')
    // } else {
    //   console.log('not ok')
    //   this.$router.replace('Login')
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
